import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";

// Captura global de promesas/errores no manejados para evitar ruido y mostrar
// un aviso amigable al usuario en lugar de fallos silenciosos.
let _lastGlobalToastAt = 0;
const friendlyGlobalToast = () => {
  const now = Date.now();
  if (now - _lastGlobalToastAt < 5000) return;
  _lastGlobalToastAt = now;
  toast.error("Ocurrió un problema inesperado. Si persiste, recarga la página.");
};

window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason;
  // Errores de red de axios ya se notifican en el interceptor; evitar duplicar.
  const isAxiosNetwork = reason?.isAxiosError && (!reason.response || reason.response.status >= 500);
  if (!isAxiosNetwork) {
    console.error("Unhandled promise rejection:", reason);
    friendlyGlobalToast();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
